import { ApolloError } from '@apollo/client'

import {
  DefinitionNode,
  DocumentNode,
  FragmentDefinitionNode,
  Kind,
} from 'graphql'

function isFragmentDefinitionNode(
  definitionNode: DefinitionNode,
): definitionNode is FragmentDefinitionNode {
  return definitionNode.kind === Kind.FRAGMENT_DEFINITION
}

function getFragmentName(fragmentDocument: DocumentNode) {
  const name = fragmentDocument.definitions.find(isFragmentDefinitionNode)?.name
    .value

  if (!name) throw new Error(`Failed to get name for ${fragmentDocument}`)

  return name
}

function getApolloErrorMessage(error: unknown): string {
  if (error instanceof ApolloError) {
    return (
      error.graphQLErrors[0]?.message ??
      (error.networkError as Error)?.message ??
      error.message
    )
  }
  if (error instanceof Error) return error.message
  return 'Unknown error'
}

const GraphQLUtils = {
  getFragmentName,
  isFragmentDefinitionNode,
  getApolloErrorMessage,
}
export default GraphQLUtils
